const configuration = (() => {
    return {
        CHECKOUT: {
            showHotelNumber: false,
            // for now do not change to true (some issues in taxes)
        },
        PDP: {
            xhrReq: 5,
            xhrReqGroup: 2
        }
    };
})();
export default configuration;
